import type { LoginDialogProps } from '@wwe-portal/ui/features/auth/login-dialog';
import { useEffect, useState } from 'react';

type UseLoginDialogStoreProps = {
  isAuthenticated?: boolean;
} & Pick<LoginDialogProps, 'title' | 'loginButtons'>;
export const useLoginDialogStore = ({
  title,
  isAuthenticated,
  loginButtons,
}: UseLoginDialogStoreProps) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (isAuthenticated) setOpen(false);
  }, [isAuthenticated]);
  const props: LoginDialogProps & { show: () => void } = {
    title,
    open,
    onClose: () => {
      setOpen(false);
    },
    loginButtons,
    show: () => {
      setOpen(true);
    },
  };
  return props;
};
